$('#productDetailModal').on('hidden.bs.modal', function (e) {
    $('.product-detail-slider').slick('unslick');
    $('.product-detail-slider').empty();

    if (history.state) {
        history.back();
    }
})

window.onpopstate = function (event) {
    if ($('#productDetailModal').hasClass("show")) {
        $('#productDetailModal').modal("hide");
    }
};
